<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable no-use-before-define -->
<!-- eslint-disable consistent-return -->
<script>
import { defineComponent, reactive, toRefs, ref, toRaw } from "@vue/composition-api";
import useEmailState from "../../../emailManage/use-email-state";
import { reverseConstructRichArea } from "../../../helper/rich-area-helper";
import { getAddresseeAndContentApi } from "../../../apis/email-manage";
import { sendLoadfactorEmail } from "../../api";

export default defineComponent({
  name: "ApplyConfirm",
  props: {
    isPlanning: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { refs, root }) {
    const { insertArguments } = useEmailState();

    const variables = reactive({
      formState: ref({
        text: "",
      }),
      rules: {
        text: [{ required: true, message: "申请原因不能为空！", trigger: "blur" }],
      },
      loading: false,
      visible: false,
    });

    // 打开对话框
    const openModal = async (row) => {
      const res = await requestAddressee();
      variables.formState = ref({
        ...row,
        content: res.content,
        contentHtml: res.contentHtml,
        recipients: res.recipientAddressStr,
        text: "",
      });
      variables.visible = true;
    };

    // 获取邮件模板地址和收件人
    const requestAddressee = async () => {
      try {
        const res = await getAddresseeAndContentApi({ mailCode: "LOAD_FACTOR_APPROVE" });
        const contentHtml = reverseConstructRichArea(res.mailContent, insertArguments);
        return {
          ...res,
          contentHtml,
        };
      } catch (err) {
        console.log(err);
      }
    };

    // 关闭对话框
    const onCancel = () => {
      refs.formRef.resetFields();
      variables.visible = false;
    };

    // 表单提交
    const onSubmit = () => {
      refs.formRef.validate(async (valid) => {
        if (valid) {
          requestSendEmail();
        } else {
          return false;
        }
      });
    };

    // 请求发送邮件
    const requestSendEmail = async () => {
      try {
        variables.loading = true;
        const parms = getSendEmailParams();
        const res = await sendLoadfactorEmail(parms);
        if (res) root.$message.warning(res);
        variables.visible = !!res;
      } catch {
        variables.visible = true;
      } finally {
        variables.loading = false;
      }
    };

    // 发送邮件请求的参数
    const getSendEmailParams = () => ({
      ...toRaw(variables.formState),
      reason: variables.formState.text,
      isPlanDepartment: props.isPlanning,
      content: `${variables.formState.content} \r\n
              </br></br>   ${variables.formState.text} \r\n
              </br></br>
               `,
    });

    return {
      openModal,
      onCancel,
      onSubmit,
      ...toRefs(variables),
    };
  },
});
</script>

<template>
  <a-drawer
    :visible="visible"
    title="满载率不达标申请"
    :mask-closable="false"
    width="700px"
    @close="onCancel"
  >
    <a-form-model
      ref="formRef"
      :model="formState"
      :rules="rules"
      label-width="100px"
      label-position="top"
    >
      <a-form-model-item label="正文信息" prop="content">
        <span v-html="formState.contentHtml"></span>
      </a-form-model-item>
      <a-form-model-item label="申请原因" prop="text">
        <a-input v-model="formState.text"></a-input>
      </a-form-model-item>
      <a-form-model-item label="收件人" prop="recipients">
        <span>{{ formState.recipients }}</span>
      </a-form-model-item>
    </a-form-model>
    <div class="drawer-bottom">
      <a-button @click="onCancel">取消</a-button>
      <a-button type="primary" class="submit-btn" :loading="loading" @click="onSubmit"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<style lang="less" scoped>
.drawer-bottom {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 56px;
  background: #fff;
  width: 100%;
  z-index: 99;
  padding: 0 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #ebedf0;

  .submit-btn {
    margin-left: 12px;
  }
}
</style>
